import React from 'react';
import { Link } from 'react-router-dom';
import naascloud from '../assets/NaaSCloudsmall.png';

const features = [
  { title: 'Zero-Touch Provisioning', desc: 'Access points configure themselves automatically when connected to the internet. No manual setup, no on-site engineers required.' },
  { title: 'Real-Time Monitoring', desc: 'Monitor all your network infrastructure from a single dashboard with live health metrics, client counts, and performance data.' },
  { title: 'AI-Powered Optimization', desc: 'Machine learning algorithms continuously tune radio parameters to maximize coverage, minimize interference, and improve throughput.' },
  { title: 'Multi-Tenant Architecture', desc: 'Manage multiple customer networks from one platform with complete isolation, role-based access, and per-tenant analytics.' },
  { title: 'Automated Operations', desc: 'Firmware updates, configuration changes, and compliance checks happen automatically on your schedule.' },
  { title: 'Scalable and Secure', desc: 'Cloud-native architecture that scales from a single site to thousands, with enterprise-grade encryption and access controls.' }
];

const NaasCloud = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>NaaS Cloud Platform</h1>

        <img src={naascloud} alt="NaaS Cloud Platform" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Our cloud-native NaaS platform empowers MSPs, cloud providers, and enterprises to deploy
          and manage WiFi and wired network services at scale. Engineered for scalability, security,
          flexibility, and simplified management, the platform redefines how organizations approach
          network operations.
        </p>

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          With just an internet connection, enterprises can deploy fully managed network services.
          Our AI platform delivers networking services with exceptional operational efficiency,
          providing comprehensive NaaS solutions tailored to the unique needs of each business.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Platform Capabilities</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {features.map((f, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{f.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Mobile App Section */}
        <div style={{
          padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
          border: '1px solid #1a2744', marginBottom: '24px',
          display: 'flex', alignItems: 'center', gap: '28px', flexWrap: 'wrap'
        }}>
          <div style={{ flex: '1 1 280px' }}>
            <h2 style={{ fontSize: '1.6rem', marginBottom: '12px' }}>Manage On the Go</h2>
            <p style={{ color: '#a0aec0', lineHeight: '1.7', marginBottom: '16px', fontSize: '0.95rem' }}>
              Take your network dashboard everywhere with the Sarvanta Mobile App.
              Monitor device health, receive real-time alerts, and manage your infrastructure
              from your phone — wherever you are.
            </p>
            <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px', marginBottom: '20px', fontSize: '0.9rem' }}>
              <li>Real-time device and client monitoring</li>
              <li>Push notifications for critical alerts</li>
              <li>Full dashboard access via secure connection</li>
              <li>Available on iOS and Android</li>
            </ul>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a href="#" style={{
                padding: '10px 24px', background: 'linear-gradient(135deg, #2563eb, #0891b2)',
                color: '#fff', borderRadius: '8px', textDecoration: 'none',
                fontWeight: '600', fontSize: '0.9rem'
              }}>App Store</a>
              <a href="#" style={{
                padding: '10px 24px', background: 'linear-gradient(135deg, #2563eb, #0891b2)',
                color: '#fff', borderRadius: '8px', textDecoration: 'none',
                fontWeight: '600', fontSize: '0.9rem'
              }}>Google Play</a>
            </div>
          </div>
          <div style={{
            flex: '0 0 200px', display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
            <div style={{
              width: '160px', height: '280px', borderRadius: '24px',
              border: '2px solid #1a2744', backgroundColor: '#000503',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 12px 40px rgba(8,145,178,0.15)',
              position: 'relative', overflow: 'hidden'
            }}>
              <div style={{
                width: '60px', height: '6px', borderRadius: '3px',
                backgroundColor: '#1a2744', position: 'absolute', top: '10px'
              }} />
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: '10px',
                  background: 'linear-gradient(135deg, #2563eb, #0891b2)',
                  margin: '0 auto 12px', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '1.2rem', color: '#fff', fontWeight: '700'
                }}>S</div>
                <p style={{ color: '#60a5fa', fontSize: '0.7rem', fontWeight: '600', margin: 0 }}>Sarvanta NaaS</p>
                <p style={{ color: '#4a5568', fontSize: '0.6rem', marginTop: '4px' }}>Tap to open</p>
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Want to learn more about our NaaS Cloud architecture?
          </p>
          <Link to="/whitepapers" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Download White Paper</Link>
        </div>
      </div>
    </div>
  );
};

export default NaasCloud;
